// Customer-facing delivery preferences. Technical/provider readiness stays separate.
export const recommendedMessages = {
 notifyOwnerOnNewBooking:true,notifyAdminsOnNewBooking:true,notifyAssignedWorker:true,
 sendCustomerEmailOnRequest:true,sendCustomerEmailOnApproval:true,sendCustomerEmailOnRejection:true,sendCustomerEmailOnCancellation:true,
 customerReminder24h:true,customerReminder2h:true,workerReminder2h:true,popupNewBookingInApp:true,
 whatsappEnabled:true,whatsappManualMessagesEnabled:true,whatsappAutoConfirmEnabled:true,whatsappAutoCancellationEnabled:true,
 whatsappReminder24hEnabled:true,whatsappReminder2hEnabled:true,whatsappTemplateRemindersLive:true,
};
export function withMessageChoice(settings,key,value){
 const next={...settings,[key]:value===true};
 if(value===true&&['whatsappReminder24hEnabled','whatsappReminder2hEnabled'].includes(key))next.whatsappTemplateRemindersLive=true;
 return next;
}
export function messageReadiness(settings,key,health){
 if(!settings[key])return {tone:'muted',label:'Apagado'};
 if(!key.startsWith('whatsapp'))return {tone:'ready',label:'Configurado para enviar'};
 if(settings.whatsappEnabled===false)return {tone:'blocked',label:'No se enviará: WhatsApp está pausado'};
 if(key.startsWith('whatsappReminder')&&!settings.whatsappTemplateRemindersLive)return {tone:'blocked',label:'No se enviará: falta completar la activación'};
 if(key==='whatsappReviewRequestEnabled'&&health?.config?.reviewTemplateApproved!==true)return {tone:'blocked',label:'Pendiente: Loop debe habilitar la plantilla de calificación'};
 if(health?.usage?.limitReached)return {tone:'blocked',label:'No se enviará: límite mensual alcanzado'};
 if(health?.config?.hasAccessToken===false||health?.config?.hasPhoneNumberId===false)return {tone:'blocked',label:'No se enviará: Loop debe configurar el canal'};
 if(!health?.config)return {tone:'unknown',label:'Configurado · falta verificar el canal'};
 return {tone:'ready',label:'Configurado para enviar'};
}
